// src/components/include/pagination.js

export const getPagination = (
  currentPage,
  totalPages,
  siblingCount = 1
) => {
  const pages = [];

  // If pages are few, show all
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // ---------- FIRST PAGES ----------
  if (currentPage <= 3) {
    pages.push(1, 2, 3, 4, "...", totalPages);
    return pages;
  }

  // ---------- LAST PAGES ----------
  if (currentPage >= totalPages - 2) {
    pages.push(
      1,
      "...",
      totalPages - 2,
      totalPages - 1,
      totalPages
    );
    return pages;
  }

  // ---------- MIDDLE ----------
  pages.push(1);
  pages.push("...");

  for (
    let i = currentPage - siblingCount;
    i <= currentPage + siblingCount;
    i++
  ) {
    pages.push(i);
  }

  pages.push("...");
  pages.push(totalPages);

  return pages;
};